import TutorialButton from '../TutorialButton'
import { mapActions, mapGetters } from 'vuex'

const mixin = {
  data: () => ({
    windowHeight: 0
  }),
  props: ['nextStep', 'content', 'previousStep', 'repeatTutorial'],
  components: {
    'tutorial-button': TutorialButton
  },
  methods: {
    setArrowPosition() {
      this.$refs.arrowTutorial.style.top = document.getElementById(this.content.arrowTarget).offsetTop + 'px'
      this.$refs.arrowTutorial.style.left = document.getElementById(this.content.arrowTarget).offsetLeft + 'px'
    },
    scrollToHighlighted(id) {
      Element.prototype.documentOffsetTop = function () {
        return this.offsetTop + (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0)
      }
      var elmnt = document.getElementById(id).documentOffsetTop() - window.innerHeight / this.content.screenPosition
      scrollTo(0, elmnt)
    },
    setOpacityElements(ids) {
      for (let i = 0; i < ids.length; i++) {
        document.getElementById(ids[i]).style.opacity = '0.15'
      }
    },
    unsetOpacityElements(ids) {
      for (let i = 0; i < ids.length; i++) {
        document.getElementById(ids[i]).style.opacity = '1'
      }
    },
    action(type, index) {
      let action = this.content[type][index].action
      if (action === 'nextStep') {
        return this.nextStep()
      } else if (action === 'previousStep') {
        return this.previousStep()
      } else if (action === 'repeatTutorial') {
        return this.repeatTutorial()
      } else if (action === 'preference') {
        return this.readTutorialAndRefreshPage(this.content.elementIdToHilight)
      }
    },
    readTutorialAndRefreshPage(id) {
      this.unsetPeseudoStyle(id)
      window.scrollTo(0, 0)
      window.location.reload()
    },
    unsetPeseudoStyle(id) {
      if (id) {
        var styleBefore = document.head.appendChild(document.createElement('style'))
        styleBefore.innerHTML = '#' + id + ':before {display: none}'
        var styleAfter = document.head.appendChild(document.createElement('style'))
        styleAfter.innerHTML = '#' + id + ':after {display: none}'
      }
    }
  },
  mounted() {
    if (this.content.arrow) {
      this.setArrowPosition()
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.windowHeight = window.innerHeight
        })
      })
    }
    if (this.content.elementIdToHilight) {
      this.scrollToHighlighted(this.content.elementIdToHilight)
    }
    if (this.content.elementsToOpacity) {
      this.setOpacityElements(this.content.elementsToOpacity)
    }
  },
  computed: {
    ...mapGetters(['preferencesWithOptions'])
  },
  watch: {
    windowHeight: function () {
      this.setArrowPosition()
    }
  },
  beforeDestroy() {
    if (this.content.elementsToOpacity) {
      this.unsetOpacityElements(this.content.elementsToOpacity)
    }
  }
}

export default mixin
